<template>
  <div class="race-candidates my-6">
    <p v-if="isContested" class="race-candidates__main">
        <span class="race-candidates__main--candidate" style="color: #d84b44;">{{ mainRepublicanCandidate.name }}</span><span v-if="mainRepublicanCandidate.incumbent"> (inc)</span>
          vs   
        <span class="race-candidates__main--candidate" style="color: #4575a1;">{{ mainDemocratCandidate.name }}</span><span v-if="mainDemocratCandidate.incumbent"> (inc)</span>
    </p>

    <p v-else class="race-candidates__main">
      <span class="race-candidates__main--candidate" :style="`color: ${uncontestedCandidateColor};`">{{ uncontestedCandidateName }} <span :style="`color: ${$vuetify.theme.currentTheme.text}; font-weight: 400; font-size: 1rem;`"><span v-if="uncontestedCandidateIncumbent">(inc)</span> (Uncontested)</span></span>
    </p>

    <p v-if="otherCandidates.length" class="race-candidates__other">
      Other: 
      <span v-for="(candidate, index) in otherCandidates" :key="candidate">{{ candidate }}<span v-if="index < otherCandidates.length - 1"> | </span></span>
    </p>
  </div>
</template>

<script>
const props = {
  mainRepublicanCandidate: {
    default: {
      name: "Joshua Hawley",
      incumbent: false,
    },
    required: true,
    type: Object,
  },
  mainDemocratCandidate: {
    default: {
      name: "Claire McCaskill",
      incumbent: true,
    },
    required: true,
    type: Object,
  },
  otherCandidates: {
    default: [],
    required: true,
    type: Array,
  },
  isContested: {
    default: true,
    required: true,
    type: Boolean,
  },
};

const computed = {
  uncontestedCandidateName() {
    if (this.isContested) return null;
    return this.mainDemocratCandidate.name.length ? this.mainDemocratCandidate.name : this.mainRepublicanCandidate.name;
  },
  uncontestedCandidateColor() {
    if (this.isContested) return null;
    return this.mainDemocratCandidate.name.length ? "#4575a1" : "#d84b44";
  },
  uncontestedCandidateIncumbent() {
    if (this.isContested) return false;
    return this.mainDemocratCandidate.name.length ? this.mainDemocratCandidate.incumbent : this.mainRepublicanCandidate.incumbent;
  },
};

export default {
  props,
  computed,
};
</script>

<style>
.race-candidates {
  text-align: center;
}

.race-candidates__main,
.race-candidates__other {
  margin: 0;
  padding: 0;
}

.race-candidates__main--candidate {
  font-size: 1.5rem;
  font-weight: 700;
}
</style>
